import { render } from "./HotSpotSummaryCard.vue?vue&type=template&id=baf89edc&scoped=true"
import script from "./HotSpotSummaryCard.vue?vue&type=script&lang=js"
export * from "./HotSpotSummaryCard.vue?vue&type=script&lang=js"

import "./HotSpotSummaryCard.vue?vue&type=style&index=0&id=baf89edc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baf89edc"]])

export default __exports__